import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListChecks, Flame } from "lucide-react";
import { api } from "@/lib/api";
import { getLessonContext } from "@/data/curriculum";

const tone = (p) => (p >= 80 ? "text-emerald-600 dark:text-emerald-400" : p >= 60 ? "text-primary" : "text-destructive");

// Dashboard card: best and latest Music Helper practice quiz score per lesson.
export const QuizScoresCard = () => {
  const [rows, setRows] = useState(null);
  const [streak, setStreak] = useState(null);
  useEffect(() => { api.get("/helper/quiz-scores").then(({ data }) => { setRows(data.lessons); setStreak(data.streak); }).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <section className="mt-10 rounded-3xl border border-border bg-card p-6" data-testid="quiz-scores-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-serif text-2xl"><ListChecks className="text-primary" size={22} /> Practice quizzes</h2>
        {streak && (
          <p className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1.5 text-sm" data-testid="quiz-streak-status">
            <Flame size={15} className="text-primary" />
            <span><span className="font-semibold" data-testid="quiz-streak-badges">{streak.badges}</span> Quiz Streak {streak.badges === 1 ? "badge" : "badges"}</span>
            <span className="text-muted-foreground">· {streak.current}/{streak.needed} perfect in a row</span>
          </p>
        )}
      </div>
      {!rows.length ? (
        <p className="mt-3 text-sm text-muted-foreground" data-testid="quiz-scores-empty">Open any lesson, tap <span className="font-semibold text-foreground">Ask the Music Helper</span> then <span className="font-semibold text-foreground">Quiz me</span> to test yourself. Your scores will appear here.</p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="py-2 pr-3">Lesson</th><th className="px-3">Best</th><th className="px-3">Latest</th><th className="px-3">Tries</th>
            </tr></thead>
            <tbody>
              {rows.map((r, i) => {
                const c = getLessonContext(r.lesson_id);
                return (
                  <tr key={r.lesson_id} className="border-t border-border" data-testid={`quiz-score-row-${i}`}>
                    <td className="py-2.5 pr-3">
                      <Link to={`/lessons/${r.lesson_id}`} className="hover:text-primary">{c ? `${c.instrument.label} · Lesson ${c.number}` : r.lesson_title || `Lesson ${r.lesson_id}`}</Link>
                      {r.lesson_title && <span className="block text-xs text-muted-foreground">{r.lesson_title}</span>}
                    </td>
                    <td className={`px-3 font-semibold ${tone(r.best)}`} data-testid={`quiz-score-best-${i}`}>{r.best}%</td>
                    <td className={`px-3 ${tone(r.latest)}`} data-testid={`quiz-score-latest-${i}`}>{r.latest_score}</td>
                    <td className="px-3 text-muted-foreground" data-testid={`quiz-score-tries-${i}`}>{r.attempts}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
